"use client";

import Image from "next/image";
import Link from "next/link";

export default function AdditionalSkillsCertifications({course,courseSections }) {
  const additional = courseSections?.AdditionalSkillsCertifications;

  // If this section doesn't exist on the course, don't render anything
  if (!additional) return null;

  const description = additional?.Description || "";

  // Nested media object from Strapi
  const media = additional?.Media;

  // If there is no media or no URL, don't render (prevents next/image errors)
  if (!media || !media.url) return null;

  // Prefer a formatted URL if you want (here I'm just using the main url)
  const imageSrc =
    media?.formats?.small?.url ||
    media?.formats?.medium?.url ||
    media?.formats?.large?.url ||
    media.url;

  const imageWidth = media?.width || 693;
  const imageHeight = media?.height || 559;

  const heading = "Additional Skills Certifications";
  const buttonText = "Apply Now";
  const buttonLink = "https://application.msu.edu.in/campus-programme-registration";

  return (
    <section className="xl:max-w-[var(--max-page-width)] xl:px-[var(--container-padding)] mx-auto py-[38px] lg:py-[50px]">
      <div className="flex flex-col lg:flex-row gap-0 px-[16px] md:px-[32px] xl:p-[0px]">
        {/* Left Column: Content */}
        <div className="lg:w-1/2 w-full px-[18px] py-[27px] sm:px-[38px] sm:py-[42px] xl:px-[60px] xl:py-[75px] bg-[#0A6EB4] text-white">
          <h2 className="text-white mb-[20px] text-[28px] md:text-[32px] font-bold leading-tight">
            {heading}
          </h2>

          <p className="text-white mb-[30px] text-[15px] md:text-[16px] leading-relaxed">
            {description}
          </p>

          {/* Apply Now Button */}
          <Link
            href={buttonLink}
            className="inline-flex items-center gap-2 bg-[#081E2D] text-white px-[24px] py-[12px] text-[14px] font-semibold transition-colors duration-300"
          >
            {buttonText}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <g clipPath="url(#clip0_3474_799)">
                <path
                  d="M12.3592 14.9568L3.31251 5.91015L4.79862 4.42404L13.8453 13.4707L13.8453 5.14852L15.9444 5.1671V17.056H4.05556L4.03698 14.9568L12.3592 14.9568Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_3474_799">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </Link>
        </div>

        {/* Right Column: Image */}
        <div className="lg:w-1/2 w-full flex justify-center lg:justify-end">
          <div className="w-full h-full min-h-[300px] lg:min-h-[400px]">
            <Image
              src={imageSrc}
              alt={media?.alternativeText || "Additional skills certifications image"}
              width={imageWidth}
              height={imageHeight}
              className="w-full h-full object-cover"
              sizes="(max-width: 1024px) 100vw, 50vw"
              priority={false}
              unoptimized
            />
          </div>
        </div>
      </div>
    </section>
  );
}
